import { render, staticRenderFns } from "./Refinements.vue?vue&type=template&id=3076aefe&"
import script from "./Refinements.vue?vue&type=script&lang=js&"
export * from "./Refinements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports